/**
 * @generated SignedSource<<d8e7813c657db19b7e43f0317a36bc34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FeedbackCardActionsRestoreRequestMutation$variables = {
  id: string;
};
export type FeedbackCardActionsRestoreRequestMutation$data = {
  readonly restoreRequest: {
    readonly feedbackAndRequestsEdge: {
      readonly node: {
        readonly cancelledByUser?: boolean;
        readonly id?: string;
        readonly isArchived?: boolean;
      };
    };
  } | null;
};
export type FeedbackCardActionsRestoreRequestMutation = {
  response: FeedbackCardActionsRestoreRequestMutation$data;
  variables: FeedbackCardActionsRestoreRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelledByUser",
      "storageKey": null
    }
  ],
  "type": "FeedbackRequestNode",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackCardActionsRestoreRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RestoreRequest",
        "kind": "LinkedField",
        "name": "restoreRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackAndRequestsEdge",
            "kind": "LinkedField",
            "name": "feedbackAndRequestsEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedbackCardActionsRestoreRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RestoreRequest",
        "kind": "LinkedField",
        "name": "restoreRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackAndRequestsEdge",
            "kind": "LinkedField",
            "name": "feedbackAndRequestsEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "caa35da00ab94d5061d0e4c00d01c08b",
    "id": null,
    "metadata": {},
    "name": "FeedbackCardActionsRestoreRequestMutation",
    "operationKind": "mutation",
    "text": "mutation FeedbackCardActionsRestoreRequestMutation(\n  $id: ID!\n) {\n  restoreRequest(id: $id) {\n    feedbackAndRequestsEdge {\n      node {\n        __typename\n        ... on FeedbackRequestNode {\n          id\n          isArchived\n          cancelledByUser\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a609ab608a3abdb22b30a3291662b76";

export default node;
